import { io } from "socket.io-client";

const socket = io("https://msuite.msesgroup.com:5001", {
  transports: ["websocket"], // Force WebSocket transport
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 2000,
});

// Check the connection status
socket.on("connect", () => {
  console.log("✅ Connected to WebSocket:", socket.id);
});

socket.on("disconnect", () => {
  console.log("❌ Disconnected from WebSocket, retrying...");
});

export default socket;